/**
 * LINE 綁定 API Service（#24 Phase B）。
 * 綁定為使用者自助；bind/unbind 需 TOTP（reuse auth_2fa）。
 */
import axiosInstance from '../api/axios';

const BASE = '/api/ee/auth/line';

export interface LineBinding {
  bound: boolean;
  line_user_id?: string | null;
  line_display_name?: string | null;
  line_picture_url?: string | null;
  bound_at?: string | null;
}

/** 取 LINE OAuth 授權 URL（前端導向 LINE）。 */
export const getAuthorizeUrl = async (): Promise<string> => {
  const res = await axiosInstance.post<{ authorize_url: string }>(`${BASE}/authorize`);
  return res.data.authorize_url;
};

/** 確認綁定（callback 導回後、輸入 TOTP）。 */
export const bindLine = async (totpCode: string): Promise<LineBinding> => {
  const res = await axiosInstance.post<LineBinding>(`${BASE}/bind`, { totp_code: totpCode });
  return res.data;
};

/** 解除綁定（需 TOTP）。 */
export const unbindLine = async (totpCode: string): Promise<void> => {
  await axiosInstance.delete(`${BASE}/bind`, { data: { totp_code: totpCode } });
};

export const getLineStatus = async (): Promise<LineBinding> => {
  const res = await axiosInstance.get<LineBinding>(`${BASE}/status`);
  return res.data;
};

// ── Phase C1：以 LINE 登入（L03 extend）──

export interface LineLoginResult {
  token: string;
  token_type: string;
  return_url?: string | null;
  policy_code?: string;
  factor_chain?: string[];
}

/** 起始 LINE 登入（unauthenticated）→ 回 LINE OAuth URL。 */
export const startLineLogin = async (): Promise<string> => {
  const res = await axiosInstance.post<{ authorize_url: string }>(`${BASE}/login`);
  return res.data.authorize_url;
};

/** 完成 LINE 登入：callback 發的 login_token + TOTP → 發 session token。 */
export const completeLineLogin = async (loginToken: string, totpCode: string): Promise<LineLoginResult> => {
  const res = await axiosInstance.post<LineLoginResult>(`${BASE}/login-complete`, {
    login_token: loginToken, totp_code: totpCode,
  });
  return res.data;
};
